// Children
import leader from './leader';
import schedule from './schedule';
import pricing from './pricing';

export default {
  ...leader,
  ...schedule,
  ...pricing,
};
